<script lang="ts">
    interface Props {
        connected: boolean;
    }

    const { connected }: Props = $props();
</script>

<div class="fixed right-[10px] bottom-[10px]">
    <div class="size-[5px] rounded-[100%]" style:background={connected ? "green" : "red"}></div>
</div>
